<template>
  <div class="wizard-step-indicator relative my-8">
    <div class="relative z-20 flex justify-between">
      <!-- eslint-disable vuejs-accessibility/no-static-element-interactions-->
      <div
        v-for="(step, index) in steps"
        :key="step.key"
        class="indicator-step-button flex flex-col items-center pointer-events-none"
        :class="[{ 'is-active ': step.active }, { 'pointer-events-auto is-completed': step.completed }]"
        @click.prevent="goToStep(step.key)"
        @keyup.prevent="goToStep(step.key)"
      >
        <div class="indicator-step-icon relative w-8 h-8">
          <span
            class="indicator-step-icon-number absolute top-0.5 left-0 w-full text-center text-black"
            :class="{ 'text-white ': step.active }"
            :aria-label="`${index + 1 } - ${ step.name }`"
          >
            {{ index + 1 }}
          </span>
          <shield-small
            class="icon absolute top-0 left-0"
          />
        </div>
        <div class="indicator-step-title text-sm hidden md:block">
          {{ step.name }}
        </div>
      </div>
    </div>
    <div class="indicator-rail absolute top-1/2 md:top-1/4 h-0.5 bg-gray-50 z-10">
      <div
        class="indicator-rail-progress h-full bg-secondary-charlie"
        :class="currentProgress"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardStepIndicator',
  components: {
    ShieldSmall: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ShieldSmall.vue'),
  },
  props: {
    steps: {
      type: Array,
      default: () => ([]),
    },
    currentStep: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentStepIndex: 0,
    };
  },
  computed: {
    gridCols() {
      return `grid-cols-${this.steps.length}`;
    },
    currentProgress() {
      return this.currentStepIndex > 0 ? `w-${this.currentStepIndex}/${this.steps.length - 1}` : 'w-0';
    },
  },
  watch: {
    currentStep(stepKey) {
      const currentStepIndex = this.steps.findIndex((step) => step.key === stepKey);
      this.steps.forEach((step, i) => {
        if (i < currentStepIndex) {
          step.completed = true;
          step.active = false;
        } else if (i === currentStepIndex) {
          step.completed = false;
          step.active = true;
        } else {
          step.completed = false;
          step.active = false;
        }
      });
      this.currentStepIndex = currentStepIndex;
    },
  },
  methods: {
    goToStep(stepName) {
      this.$parent.goToStep(stepName);
      this.$emit('goToStep', stepName);
    },
  },
}
</script>
